// Conteo fisico de inventario desde el POS.
// Reusa las mismas vistas del contexto empresa: cambian los nombres de ruta
// (los resuelve inventario.mixin) y la sucursal, que sale de la sesion del POS.
// `sinCaja` porque contar no requiere caja abierta ni arqueo.
const meta = { sinCaja: true, permiso: 'realizar_inventario' };

export default [
  {
    path: 'inventarios',
    name: 'pos.inventarios',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalInventarios.vue'),
    redirect: { name: 'pos.inventarios.list' },
    meta,
    children: [
      {
        path: '',
        name: 'pos.inventarios.list',
        component: () => import('@/views/empresa/sucursales/productos/inventario/components/SucursalInventarioList.vue'),
        meta,
      },
    ],
  },
  {
    path: 'inventarios/nuevo',
    name: 'pos.inventarios.nuevo',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioNuevo.vue'),
    meta,
  },
  {
    path: 'inventarios/:inventarioUuid',
    name: 'pos.inventarios.iniciado',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioIniciado.vue'),
    props: true,
    meta,
  },
  {
    path: 'inventarios/:inventarioUuid/categoria/:categoriaId',
    name: 'pos.inventarios.categoria',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioCategoria.vue'),
    props: true,
    meta,
  },
  {
    path: 'inventarios/:inventarioUuid/finalizar',
    name: 'pos.inventarios.finalizar',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioFinalizar.vue'),
    props: true,
    meta,
  },
  {
    path: 'inventarios/resumen/:inventarioUuid',
    name: 'pos.inventarios.resumen',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioResumen.vue'),
    props: true,
    meta,
  },
];
